export const filtersModule = {
  namespaced: true,
  state: {
    brandFilter: [],
    textFilter: "",
    isFilterDrawerOpen: null
  },
  mutations: {
    toggleFilterNavigationDrawer(state, open) {
      state.isFilterDrawerOpen = open;
    },
    setBrandFilter(state, v) {
      state.brandFilter = v;
    },
    setTextFilter(state, v) {
      state.textFilter = v;
    }
  },
  getters: {
    isFilterDrawerOpen: state => state.isFilterDrawerOpen,
    brandFilter: state => state.brandFilter,
    textFilter: state => state.textFilter
  }
};
